export const CONTRACT_TERMS = [0, 1, 12, 24];
